import BaseEntity from '../BaseEntity';
import LcovLine from './LcovLine';
export default class CoverageEntry extends BaseEntity {
    constructor(data) {
        super();
        this.sourceFile = this.parseProperty(data, 'sourceFile');
        this.lines = this.parseProperty(data, 'lines').map(line => new LcovLine(line));
    }
}
